var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButton1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43.665,
    height: 52.324,
    viewBox: "0 0 11.553 13.844",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.86 4.554v-.438a4.083 4.083 0 10-8.167 0v.438A1.828 1.828 0 000 6.374v5.645a1.828 1.828 0 001.826 1.825h7.902a1.827 1.827 0 001.825-1.825V6.374a1.828 1.828 0 00-1.693-1.82zm-6.773-.005v-.433a2.69 2.69 0 015.38 0v.433zm7.072 1.825v5.645a.433.433 0 01-.432.432H1.826a.433.433 0 01-.432-.432V6.374a.433.433 0 01.432-.432h7.902a.433.433 0 01.431.432z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.429 9.067V7.915a.69.69 0 00-1.379 0v1.153a1.163 1.163 0 101.379 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton1);
export default __webpack_public_path__ + "static/media/button1.ee8cb657.svg";
export { ForwardRef as ReactComponent };